export default __webpack_public_path__ + "static/media/sun.f13e59e0.svg";